import { render, staticRenderFns } from "./RecentlyRegisteredTenantsWidget.vue?vue&type=template&id=fb07415e&scoped=true&"
import script from "./RecentlyRegisteredTenantsWidget.vue?vue&type=script&lang=js&"
export * from "./RecentlyRegisteredTenantsWidget.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyRegisteredTenantsWidget.vue?vue&type=style&index=0&id=fb07415e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb07415e",
  null
  
)

export default component.exports